import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import Currency from "@components-shared/Currency";
import { useRootAppStore } from "@hooks";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

export default observer(function ModalBody(props: { store: CashoutStore }) {
	const t = useTranslation().t;
	const store = useRootAppStore();

	if (props.store.openedAutosellModalBetSlipId == null) {
		console.error("Expected cashout modal, got null.");
		return null;
	}

	const thresholdInputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const timer = setTimeout(() => {
			thresholdInputRef.current?.focus();
		}, 1);
		return () => clearTimeout(timer);
	}, []);

	if (props.store.isAutosellModalCashedOut) {
		return (
			<div className="message--base message--success--alt">
				{t("mybets:SUCCESS_MESSAGE", {
					amount: props.store.autosellModalCashoutGain,
					currency: store.userAuthStore.currency,
				})}
			</div>
		);
	} else if (props.store.isAutocashoutUnavailable) {
		return (
			<>
				{props.store.isConfigurationExists &&
					props.store.secureWinAmount && (
						<div className="form__field">
							<label
								htmlFor="definedAutoCashoutAmount"
								className="label"
							>
								{t("mybets:CASHOUT.SECURE_WIN_DESCRIPTION")}
							</label>
							<input
								id="definedAutoCashoutAmount"
								className="input input--med"
								type="number"
								value={props.store.secureWinAmount}
								disabled
							/>
						</div>
					)}
				<div className="message--base message--warning">
					{t("mybets:CASHOUT.AUTO_CASHOUT_UNAVAILABLE")}
				</div>
			</>
		);
	} else {
		return (
			<>
				<div className="form__field">
					<label htmlFor="setAutoCashoutAmount" className="label">
						{t("mybets:CASHOUT.SECURE_WIN_DESCRIPTION")}:
					</label>
					<input
						id="setAutoCashoutAmount"
						className={classNames("input input--med", {
							"input-validation-error":
								!props.store.isAutosellFormValid,
						})}
						type="number"
						step=".01"
						min="0"
						value={props.store.secureWinAmount || ""}
						onChange={(e) =>
							props.store.handleChange(e.target.value)
						}
						ref={thresholdInputRef}
					/>
				</div>
				<div className="form__field u-mar--bottom--reset u-type--sml">
					<div
						className={classNames("row", {
							"u-type--color--text--secondary":
								props.store.isMinThresholdValid,
							"u-type--color--error":
								!props.store.isMinThresholdValid,
						})}
					>
						<div className="col col-sml-6">
							{t("mybets:CASHOUT.MIN")}:
						</div>
						<div className="col col-sml-6 u-type--right">
							{props.store.minThreshold}{" "}
							<Currency component="span" />
						</div>
					</div>
					<div
						className={classNames("row", {
							"u-type--color--text--secondary":
								props.store.isMaxThresholdValid,
							"u-type--color--error":
								!props.store.isMaxThresholdValid,
						})}
					>
						<div className="col col-sml-6">
							{t("mybets:CASHOUT.MAX")}:
						</div>
						<div className="col col-sml-6 u-type--right">
							{props.store.maxThreshold}{" "}
							<Currency component="span" />
						</div>
					</div>
				</div>
			</>
		);
	}
});
